import checkIcon from '../../assets/checkIcon.png';
import { GeneralTexts } from "../../language/Texts";
import AccordionComponent from '../accordionComponent/AccordionComponent';
import SectionTitle from '../sectionTitle/SectionTitle';

import ASME from '../../assets/ASME.png';
import ATEX from '../../assets/ATEX.png';
import CE from '../../assets/CE.png';
import CML from '../../assets/CML.png';
import EAC from '../../assets/EAC.png';
import EHEDG from '../../assets/EHEDG.png';
import FM from '../../assets/FM.png';
import GL from '../../assets/GL.png';
import KOSHA from '../../assets/KOSHA.png';
import NFPA from '../../assets/NFPA.png';
import USDA from '../../assets/USDA.png';
import werkszertifikat from '../../assets/werkszertifikat.png';
import { IAttribute } from '../../models/IOutputData';

import './CertificateComponent.scss';

interface CertificateProps {
    attributes: IAttribute[] | undefined;
}

function CertificateComponent({ attributes }: CertificateProps) {
    const certificateImages: { [key: string]: string } = {
        "Factory standard": werkszertifikat,
        ASME: ASME,
        ATEX: ATEX,
        CML: CML,
        NFPA: NFPA,
        FM: FM,
        EHEDG: EHEDG,
        GL: GL,
        KOSHA: KOSHA,
        USDA: USDA,
        EAC: EAC,
        CE: CE
    };

    // Filter attributes to get only those that have a matching image
    let validAttributes = attributes?.filter(attr => certificateImages[attr.title]);

    // If 'Factory standard' exists among the attributes, sort it to appear first
    if (validAttributes && validAttributes.length > 1) {
        validAttributes = [...validAttributes].sort((a, b) => {
            if (a.title === 'Factory standard' && b.title !== 'Factory standard') return -1;
            if (b.title === 'Factory standard' && a.title !== 'Factory standard') return 1;
            return 0;
        });
    }

    // If no valid attributes exist, return null to render nothing
    if (!validAttributes || validAttributes.length === 0) {
        return null;
    }

    const componentBody = (
        <div className='certificate_container'>
            {validAttributes.map((attribute, index) => {
                const certificateImage = certificateImages[attribute.title];
                return (
                    <div key={index} className="self_certificate_wrapper">
                        <img className="certificate_image" src={certificateImage} alt="certificate" />
                        <span className="certificate_text">{attribute.value}</span>
                    </div>
                )
            })}
        </div>
    );

    const titleComponent =
        <SectionTitle
            icon={<img className="section_title_icon" alt="check icon" src={checkIcon} />}
            title={GeneralTexts.certificates} />

    return (
        <AccordionComponent
            title={titleComponent}
            body={componentBody}
        />
    )
}

export default CertificateComponent
